// extracted by mini-css-extract-plugin
module.exports = {"tagsContainer":"styles_tagsContainer__W_rUu","tag":"styles_tag__gMnUd","tagDivider":"styles_tagDivider__iuNq9"};